import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Sparkle, ArrowRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RALPH_USER_ID = "5ae423a3-f5e7-495c-adb5-2b550a50acc6";

export default function PlansPublic() {
  const { userIdOrSlug } = useParams();
  const targetId = userIdOrSlug || RALPH_USER_ID;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/dojo-tariffs/public/${targetId}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Erreur"))
      .finally(() => setLoading(false));
  }, [targetId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <Loader2 className="animate-spin text-impact-gold" size={48} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-white">
        {error}
      </div>
    );
  }

  // Groupe par discipline (depuis le label parsé)
  const groups = {};
  for (const t of data.tariffs) {
    const disc = (t.label || "").split(" ")[0] || "Autre";
    groups[disc] = groups[disc] || [];
    groups[disc].push(t);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-950 via-zinc-900 to-black text-white" data-testid="plans-public-page">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="ticker text-impact-gold text-xs mb-2">— TARIFS OFFICIELS</div>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tight mb-3" data-testid="plans-title">{data.dojo_name}</h1>
          <p className="text-zinc-400 text-lg">{data.count} programmes · choisissez votre voie</p>
        </div>

        {/* CTA Inscription */}
        <div className="bg-impact-red text-white rounded-2xl p-6 mb-10 text-center">
          <p className="ticker text-white/80 mb-2">PRÊT À COMMENCER ?</p>
          <h2 className="font-display font-bold text-2xl mb-3">Cours d'essai 19,99 $ · Forfait Découverte 2 semaines 120 $</h2>
          <a href="/inscription" className="inline-flex items-center gap-2 bg-white text-impact-red px-6 py-3 ticker font-bold hover:bg-impact-gold transition-colors" data-testid="cta-inscription">
            S'inscrire maintenant <ArrowRight size={16} />
          </a>
        </div>

        {/* Tarifs groupés */}
        {Object.entries(groups).map(([disc, tariffs]) => (
          <div key={disc} className="mb-10">
            <h3 className="ticker text-impact-gold mb-4 flex items-center gap-2">
              <Sparkle size={14} /> {disc}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {tariffs.map((t) => (
                <div key={t.id} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 hover:border-impact-gold/50 transition-colors" data-testid={`tariff-card-${t.id}`}>
                  <div className="text-sm font-medium mb-1">{t.label}</div>
                  {t.age_range && <div className="text-xs text-zinc-500 mb-2">{t.age_range}</div>}
                  <div className="font-mono text-3xl font-bold text-impact-gold mb-1">
                    {t.price.toFixed(2)} $
                    <span className="text-sm text-zinc-400 font-sans"> / {t.billing_cycle === "horaire" ? "h" : t.billing_cycle}</span>
                  </div>
                  {t.notes && <p className="text-xs text-zinc-400 mt-2 line-clamp-2">{t.notes}</p>}
                  {t.stripe_payment_url && (
                    <a href={t.stripe_payment_url} target="_blank" rel="noreferrer" data-testid={`plan-pay-${t.id}`}
                      className="mt-3 flex items-center justify-center gap-2 bg-impact-gold text-black py-2.5 rounded-lg font-bold hover:bg-white transition-colors">
                      {t.stripe_mode === "subscription" ? "S'abonner" : "Payer"} <ArrowRight size={15} />
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="text-center text-xs text-zinc-500 mt-12 pt-6 border-t border-white/10">
          Mon Assistant Pro · Tarifs officiels — sujets à ajustement annuel coût de la vie
        </div>
      </div>
    </div>
  );
}
